import { useTranslation } from "react-i18next";

export function Loading({ label }: { label?: string }) {
  const { t } = useTranslation();
  return (
    <div role="status" className="flex h-full min-h-32 items-center justify-center p-8 text-sm text-gray-700">
      {label ?? t("app.loading")}
    </div>
  );
}
